export default __webpack_public_path__ + "static/media/node_js_logo.b235615d.png";